module.exports = __webpack_public_path__ + "assets/empty.68ff832e.svg";